import { cn } from "@/lib/utils";

/**
 * Bloom — the brand mascot, now with moods.
 * Moods: "happy" (default), "thinking", "encouraging", "celebrating".
 * Stays charming for Year 1 yet refined enough for Year 6.
 */
export function Mascot({
  size = 120,
  className,
  animated = true,
  mood = "happy",
  "data-testid": testId,
}) {
  return (
    <svg
      width={size}
      height={size * (150 / 140)}
      viewBox="0 0 140 150"
      fill="none"
      role="img"
      aria-label={`Bloom mascot, ${mood}`}
      data-testid={testId}
      className={cn(animated && "motion-safe:animate-float", className)}
    >
      {/* sparkles for celebrating */}
      {mood === "celebrating" && (
        <g className="motion-safe:animate-pop-in">
          <path d="M20 40 l2 6 6 2 -6 2 -2 6 -2 -6 -6 -2 6 -2z" className="fill-secondary" />
          <path d="M118 54 l1.6 5 5 1.6 -5 1.6 -1.6 5 -1.6 -5 -5 -1.6 5 -1.6z" className="fill-teal" />
          <circle cx="112" cy="30" r="3" className="fill-primary" />
        </g>
      )}

      {/* leaves */}
      <ellipse cx="52" cy="34" rx="17" ry="9.5" transform="rotate(-34 52 34)" className="fill-teal" />
      <ellipse cx="88" cy="34" rx="17" ry="9.5" transform="rotate(34 88 34)" className="fill-teal" />
      <path d="M58 39 C50 37 44 35 39 31" className="stroke-teal-foreground/30" strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M82 39 C90 37 96 35 101 31" className="stroke-teal-foreground/30" strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* stem */}
      <path d="M70 52 L70 30" className="stroke-teal" strokeWidth="6" strokeLinecap="round" />
      {/* face */}
      <circle cx="70" cy="94" r="44" className="fill-primary" />
      <ellipse cx="56" cy="78" rx="20" ry="14" className="fill-white/15" />
      {/* cheeks */}
      <circle cx="48" cy="102" r="7.5" className="fill-secondary/70" />
      <circle cx="92" cy="102" r="7.5" className="fill-secondary/70" />

      {/* eyes + mouth by mood */}
      {mood === "happy" && (
        <>
          <ellipse cx="57" cy="90" rx="4.2" ry="6" fill="#2B2D42" />
          <ellipse cx="83" cy="90" rx="4.2" ry="6" fill="#2B2D42" />
          <circle cx="58.6" cy="87.5" r="1.6" fill="#FFFFFF" />
          <circle cx="84.6" cy="87.5" r="1.6" fill="#FFFFFF" />
          <path d="M56 106 Q70 119 84 106" stroke="#2B2D42" strokeWidth="4.5" strokeLinecap="round" fill="none" />
        </>
      )}

      {mood === "thinking" && (
        <>
          <path d="M49 82 Q56 78 63 82" stroke="#2B2D42" strokeWidth="3" strokeLinecap="round" fill="none" />
          <ellipse cx="58" cy="88" rx="4" ry="5.5" fill="#2B2D42" />
          <ellipse cx="84" cy="88" rx="4" ry="5.5" fill="#2B2D42" />
          <circle cx="59.4" cy="85.8" r="1.5" fill="#FFFFFF" />
          <circle cx="85.4" cy="85.8" r="1.5" fill="#FFFFFF" />
          <path d="M62 110 Q72 107 80 111" stroke="#2B2D42" strokeWidth="4.5" strokeLinecap="round" fill="none" />
          <circle cx="104" cy="74" r="3.4" className="fill-secondary" />
          <circle cx="112" cy="66" r="2.4" className="fill-secondary/80" />
        </>
      )}

      {mood === "encouraging" && (
        <>
          <ellipse cx="57" cy="90" rx="4.2" ry="6" fill="#2B2D42" />
          <circle cx="58.6" cy="87.5" r="1.6" fill="#FFFFFF" />
          <path d="M77 92 Q83 86 89 92" stroke="#2B2D42" strokeWidth="4" strokeLinecap="round" fill="none" />
          <path d="M55 104 Q70 120 85 104" stroke="#2B2D42" strokeWidth="4.5" strokeLinecap="round" fill="none" />
          <path d="M64 110 Q70 116 76 110" className="fill-destructive/70" />
        </>
      )}

      {mood === "celebrating" && (
        <>
          <path d="M50 92 Q57 85 64 92" stroke="#2B2D42" strokeWidth="4" strokeLinecap="round" fill="none" />
          <path d="M76 92 Q83 85 90 92" stroke="#2B2D42" strokeWidth="4" strokeLinecap="round" fill="none" />
          <path d="M54 101 Q70 122 86 101 Z" fill="#2B2D42" />
          <path d="M61 101 Q70 109 79 101 Z" className="fill-destructive/70" />
        </>
      )}
    </svg>
  );
}

export default Mascot;
